module.exports = __webpack_public_path__ + "public/img/no-pict.60c70b0f.png";